import React, { useState, useEffect } from "react";

import styles from "./Agenda.module.css";
import { cardColor, STATUS_CONSULTA, TagAgendamentos } from "./TagAgendamentos";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import Circle from "@mui/icons-material/Circle";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Chip from "@mui/material/Chip";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";

import api from "../../services/api";
import ModalDialogs from "../../components/ModalDialogs";

import {
  FieldDatePicker,
  FieldSelect,
  FieldAutocomplete,
  FieldTimePicker,
} from "../../components/Fields";

import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

import { formatDateISO8601 } from "../../utils/formatarData";
import dayjs from "dayjs";
import {
  requestCancelAppointment,
  requestUpdateAgendarConsulta,
} from "../../services/cadastroService";
import { getItemDecrypt } from "../../utils/cryptoData";

const horarios = {
  6: "06:00",
  7: "07:00",
  8: "08:00",
  9: "09:00",
  10: "10:00",
  11: "11:00",
  12: "12:00",
  13: "13:00",
  14: "14:00",
  15: "15:00",
  16: "16:00",
  17: "17:00",
  18: "18:00",
};

const consultTypes = [
  {
    id: 1,
    label: "Presencial",
  },
  {
    id: 2,
    label: "Teleconsulta",
  },
  {
    id: 3,
    label: "Híbrida",
  },
];
export function Agenda({ consultasSelecionadas, dataSelecionada }) {
  const [format, setFormat] = useState("Mês");
  const [type, setType] = useState("Calendário");
  const [date, setDate] = useState(new Date());
  const [dias, setDias] = useState(
    getDaysInMonth(date.getMonth(), date.getFullYear())
  );
  const [todasConsultas, setTodasConsultas] = useState([]);
  const [consultas, setConsultas] = useState([]);
  const [user, setUser] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);

  const [patient, setPatient] = useState("");
  const [patientList, setPatientList] = useState([]);
  const [internalHealthTeam, setInternalHealthTeam] = useState([]);
  const [internalHealthTeamList, setInternalHealthTeamList] = useState([]);
  const [externalHealthTeam, setExternalHealthTeam] = useState([]);
  const [externalHealthTeamList, setExternalHealthTeamList] = useState([]);

  const [openErro, setOpenErro] = useState(false);
  const [mensagemErro, setMensagemErro] = useState("");

  const [AppointmentSelected, setAppointmentSelected] = useState({});
  const [consultType, setConsultType] = useState("");
  const [appointmentDate, setAppointmentDate] = useState(null);
  const [appointmentTime, setAppointmentTime] = useState(null);
  const [editing, setEditing] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isSend, setIsSend] = useState(false);
  const [openModalSuccess, setOpenModalSuccess] = useState(false);
  const [openModalCancelAppointment, setOpenCancelAppointment] =
    useState(false);

  const firstDayOfWeek = dias[0].getDay();
  const emptyDivs = Array.from({ length: firstDayOfWeek }, () => null);

  const vinculo = getItemDecrypt("vinculo_ativo");
  const usuario = getItemDecrypt("usuario");

  let perfilAdministrador = vinculo.perfil.id === 1;

  useEffect(() => {
    const { estabelecimento, id } = getItemDecrypt("vinculo_ativo");
    getAppointmentsAll();
    setUser(usuario);
    getData(estabelecimento.id, id);
    getHealthTeam(estabelecimento.id, usuario.co_id);
  }, []);

  function getAppointmentsAll() {
    api.get(`/agenda/${usuario.co_id}`).then((response) => {
      setTodasConsultas(response.data);
      setConsultas(response.data);
    });
  }

  useEffect(() => {
    const consultasFiltradas = filtrarPorConsultasSeleciondas();
    setConsultas(consultasFiltradas);
  }, [consultasSelecionadas]);

  useEffect(() => {
    setDate(dataSelecionada);
    setDias(
      getDaysInMonth(dataSelecionada.getMonth(), dataSelecionada.getFullYear())
    );
  }, [dataSelecionada]);

  async function getData(id_estabelecimento, id_vinculo) {
    try {
      const { data } = await api.post("/pacientes-vivos/", {
        id_estabelecimento,
        id_vinculo: id_vinculo,
      });
      setPatientList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }
  async function getHealthTeam(id_estabelecimento, id_usuario) {
    try {
      const { data } = await api.post(`/profissionais-internos/`, {
        id_estabelecimento: id_estabelecimento,
        id_usuario: id_usuario,
      });

      const response = await api.get(
        `/profissionais-externos/${id_estabelecimento}`
      );

      setInternalHealthTeamList(data);
      setExternalHealthTeamList(response.data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  const handleModalOpen = (appointment) => {
    setAppointmentSelected(appointment);
    setConsultType(appointment.id_categoria);
    setPatient(
      patientList.find(
        (paciente) => paciente.nome === appointment.paciente.nome
      )
    );
    var data = appointment.dataConsulta.split("T");
    data = `${data[0]}T${appointment.inicio}:00`;

    setAppointmentDate(dayjs(data));
    setAppointmentTime(dayjs(data));

    if (appointment.participantes) {
      const internalHealthTeamData = internalHealthTeamList.filter((pf) =>
        appointment.participantes.find((item) => pf.co_id === item.id_vinculo)
      );
      setInternalHealthTeam(internalHealthTeamData);

      const externalHealthTeamData = externalHealthTeamList.filter((pf) =>
        appointment.participantes.find((item) => pf.co_id === item.id_vinculo)
      );
      setExternalHealthTeam(externalHealthTeamData);
    }

    setOpenModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
    setConsultType("");
    setPatient("");
    setAppointmentDate(null);
    setAppointmentTime(null);
    setOpenCancelAppointment(false);
    setInternalHealthTeam([]);
    setAppointmentSelected({});
    setEditing(false);
  };

  const filtrarPorConsultasSeleciondas = () => {
    return todasConsultas.filter((consulta) => {
      const idPerfil = consulta.vinculo.perfil.id;
      return consultasSelecionadas.includes(idPerfil);
    });
  };

  function getDaysInMonth(month, year) {
    var date = new Date(year, month, 1);
    var days = [];

    while (date.getMonth() === month) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return days;
  }

  const getLastSunday = () => {
    const date = new Date();
    const today = date.getDate();
    const currentDay = date.getDay();
    const newDate = date.setDate(today - (currentDay || 7));
    return new Date(newDate);
  };

  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSubmit = async () => {
    if (patient === "") {
      setOpenErro(true);
      setMensagemErro("Nome do paciente é um campo obrigatório.");
      return;
    }
    if (internalHealthTeam.length === 0 && perfilAdministrador) {
      setOpenErro(true);
      setMensagemErro("Equipe de saúde é um campo obrigatório.");
      return;
    }
    setIsSend(true);

    const data = {
      idConsulta: AppointmentSelected.id,
      idVinculo: vinculo.id,
      idPaciente: patient.id,
      dataAgendamento: dayjs(appointmentDate).format("YYYY-MM-DD"),
      horaAgendamento: dayjs(appointmentTime).format("HH:mm"),
      tipoConsulta: consultType,
      equipeDeSaudeTotal: [...internalHealthTeam, ...externalHealthTeam],
    };
    const response = await requestUpdateAgendarConsulta(data);

    if (response.hasOwnProperty("error")) {
      setMensagemErro(response.error);
      setOpenErro(true);
      setIsSend(false);
      return;
    }
    setIsSend(false);
    handleModalClose();
    setOpenModalSuccess(true);
    getAppointmentsAll();
  };

  const handleCancelAppointment = async () => {
    setIsSend(true);
    const data = {
      idConsulta: AppointmentSelected.id,
      idVinculo: vinculo.id,
    };
    const response = await requestCancelAppointment(data);
    if (response.hasOwnProperty("error")) {
      setMensagemErro(response.error);
      setOpenErro(true);
      setIsSend(false);
    } else {
      setIsSend(false);
      setOpenModalSuccess(true);
      handleModalClose();
      getAppointmentsAll();
    }
  };

  const handleConsultasMesCalendario = (dia) => {
    const consultaDia = consultas.filter((consulta) => {
      const data = new Date(consulta.dataConsulta);
      const adjustedData = new Date(
        data.getTime() + data.getTimezoneOffset() * 60000
      );

      return adjustedData.toDateString() === dia.toDateString();
    });

    return (
      <div className={styles.monthAgenda}>
        <div>{dia.getDate()}</div>
        {consultaDia.map((consulta) => (
          <TagAgendamentos
            start={consulta.inicio}
            end={consulta.fim}
            type={
              consulta.participantes.length > 1
                ? "Multidisplinar"
                : consulta.vinculo.perfil.descricao
            }
            status={consulta.status}
            onClick={() => {
              handleModalOpen(consulta);
            }}
          />
        ))}
      </div>
    );
  };

  const handleConsultaMesLista = (dia) => {
    const consultaDia = consultas.filter((consulta) => {
      const data = new Date(consulta.dataConsulta);
      const adjustedData = new Date(
        data.getTime() + data.getTimezoneOffset() * 60000
      );

      return adjustedData.toDateString() === dia.toDateString();
    });

    return (
      <Stack
        direction="row"
        gap={2}
        sx={{
          minHeight: "5rem",
          width: "100%",
          borderBottom: "1px solid #ccc",
          padding: { xs: "8px 16px", sm: "16px 32px" },
          display: "flex",
          alignItems: "center",
          color: "#737373",
        }}
      >
        <Typography
          sx={{
            width: "10rem",
            textAlign: "left",
            textTransform: "capitalize",
            fontWeight: 500,
            fontSize: "18px",
            whiteSpace: "nowrap",
          }}
        >
          {String(dia.getDate()).padStart(2, "0")}{" "}
          {dia.toLocaleString("pt-br", { month: "short" })},{" "}
          {dia.toLocaleString("pt-br", { weekday: "short" })}
        </Typography>
        <Stack>
          {consultaDia.map((consulta) => {
            const type =
              consulta.participantes.length > 1
                ? "Multidisplinar"
                : consulta.vinculo.perfil.descricao;
            return (
              <Button
                onClick={() => {
                  handleModalOpen(consulta);
                }}
                size="small"
                icon
                sx={{
                  textTransform: "capitalize",
                  fontWeight: 400,
                  color: "#737373",
                  width: "fit-content",
                  textAlign: "left",
                }}
              >
                <Stack sx={{ fontSize: "16px" }}>
                  <Stack
                    direction="row"
                    gap={1}
                    alignItems={"center"}
                    flexWrap={"wrap"}
                  >
                    <Stack direction="row" gap={1} alignItems={"center"}>
                      <Circle
                        style={{
                          fill: cardColor(type),
                          fontSize: "16px",
                          mt: 1,
                        }}
                      />
                      <Typography
                        component="span"
                        fontSize={"15px"}
                        fontWeight={700}
                      >
                        {consulta.inicio} até {consulta.fim} Consulta {type}{" "}
                      </Typography>
                    </Stack>

                    <Typography component="span">
                      - Paciente: {consulta.paciente.nome}
                    </Typography>
                  </Stack>
                  <Typography
                    component={"span"}
                    variant="caption"
                    fontWeight={700}
                    textAlign={"center"}
                  >
                    {STATUS_CONSULTA[consulta.status]}
                  </Typography>
                </Stack>
              </Button>
            );
          })}
        </Stack>
      </Stack>
    );
  };

  const handleAgendamentosPorHorario = (horario) => {
    horario = parseInt(horario);
    const consultasHorario = consultas.filter((consulta) => {
      let data = new Date(consulta.dataConsulta);
      data = new Date(data.getTime() + data.getTimezoneOffset() * 60000);

      const mesmoDia =
        data.getDate() === date.getDate() &&
        data.getMonth() === date.getMonth() &&
        data.getFullYear() === date.getFullYear();

      const consultaInicio = parseInt(consulta.inicio.split(":")[0]);

      return consultaInicio === horario && mesmoDia;
    });

    return consultasHorario.map((consulta) => {
      return (
        <TagAgendamentos
          start={consulta.inicio}
          end={consulta.fim}
          type={
            consulta.participantes.length > 1
              ? "Multidisplinar"
              : consulta.vinculo.perfil.descricao
          }
          status={consulta.status}
          onClick={() => {
            handleModalOpen(consulta);
          }}
        />
      );
    });
  };

  return (
    <Box>
      <Stack
        flexDirection={"row"}
        sx={{ justifyContent: "space-between", padding: "24px 0px" }}
        flexWrap={"wrap"}
        gap={2}
      >
        <Stack direction="row" sx={{ display: "flex", alignItems: "center" }}>
          <Button
            variant="outlined"
            color="primary"
            aria-haspopup="true"
            onClick={handleClick}
          >
            {format}
            <KeyboardArrowDown />
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem onClick={() => setFormat("Dia")}>Dia</MenuItem>
            <MenuItem onClick={() => setFormat("Mês")}>Mês</MenuItem>
            <MenuItem disabled onClick={() => setFormat("Semana")}>
              Semana
            </MenuItem>
          </Menu>

          <Stack flexDirection={"row"} alignItems={"center"}>
            <Button
              onClick={() => {
                let newDate = date;
                if (format == "Dia") {
                  newDate.setDate(newDate.getDate() - 1);
                } else {
                  newDate.setMonth(newDate.getMonth() - 1);
                }
                setDate(newDate);
                setDias(getDaysInMonth(date.getMonth(), date.getFullYear()));
              }}
            >
              <ArrowBackIos
                style={{
                  color: "#1E729F",
                  cursor: "pointer",
                }}
              />
            </Button>

            {format == "Dia" ? (
              <Typography noWrap>
                {date.toLocaleString("pt-br", { day: "numeric" })} de{" "}
                {date.toLocaleString("pt-br", { month: "long" })} de{" "}
                {date.toLocaleString("pt-br", { year: "numeric" })}
              </Typography>
            ) : (
              <Typography noWrap>
                {date.toLocaleString("pt-br", { month: "long" })} de{" "}
                {date.toLocaleString("pt-br", { year: "numeric" })}
              </Typography>
            )}

            <Button
              onClick={() => {
                let newDate = date;
                if (format === "Dia") {
                  newDate.setDate(newDate.getDate() + 1);
                } else {
                  newDate.setMonth(newDate.getMonth() + 1);
                }

                setDate(newDate);
                setDias(getDaysInMonth(date.getMonth(), date.getFullYear()));
              }}
            >
              <ArrowForwardIos
                style={{
                  color: "#1E729F",
                  cursor: "pointer",
                }}
              />
            </Button>
          </Stack>
        </Stack>

        <ButtonGroup
          variant="outlined"
          aria-label="outlined primary button group"
        >
          <Button
            startIcon={
              <FormatListBulletedIcon
                style={{ fill: type === "lista" ? "white" : "#1E729F" }}
              />
            }
            sx={{
              textTransform: "none",
              fontSize: "1rem",
              color: type === "lista" ? "white" : "#1E729F",
            }}
            variant={type === "lista" ? "contained" : "outlined"}
            onClick={() => setType("lista")}
          >
            Lista
          </Button>
          <Button
            endIcon={
              <CalendarMonthOutlinedIcon
                style={{ fill: type === "Calendário" ? "white" : "#1E729F" }}
              />
            }
            sx={{
              textTransform: "none",
              fontSize: "1rem",
              color: type === "Calendário" ? "white" : "#1E729F",
            }}
            variant={type === "Calendário" ? "contained" : "outlined"}
            onClick={() => setType("Calendário")}
          >
            Calendário
          </Button>
        </ButtonGroup>
      </Stack>
      <Divider sx={{ mb: 2 }} />
      {format === "Mês" && type === "Calendário" ? (
        <>
          <div className={styles.weekDays}>
            <div className={styles.dayWeek}>
              <div>Domingo</div>
            </div>
            <div className={styles.dayWeek}>
              <div>Segunda</div>
            </div>
            <div className={styles.dayWeek}>
              <div>Terça</div>
            </div>
            <div className={styles.dayWeek}>
              <div>Quarta</div>
            </div>
            <div className={styles.dayWeek}>
              <div>Quinta</div>
            </div>
            <div className={styles.dayWeek}>
              <div>Sexta</div>
            </div>
            <div className={styles.dayWeek}>
              <div>Sábado</div>
            </div>
          </div>

          <div className={styles.month}>
            {emptyDivs.map((index) => (
              <div className={styles.monthAgenda}></div>
            ))}

            {dias.map((dia, i) => {
              return handleConsultasMesCalendario(dia);
            })}
          </div>
        </>
      ) : (
        <></>
      )}

      {format == "Mês" && type == "lista" ? (
        <>
          <Box sx={{ border: "1px solid #ccc", p: 0, borderRadius: "5px" }}>
            {dias.map((dia, i) => {
              return handleConsultaMesLista(dia);
            })}
          </Box>
        </>
      ) : (
        <></>
      )}

      {format === "Semana" && type === "lista" && (
        <>
          <Box sx={{ border: "1px solid #ccc", p: 0, borderRadius: "5px" }}>
            <Stack
              direction="row"
              sx={{
                maxHeight: "5rem",
                width: "100%",
                borderBottom: "1px solid #ccc",
                p: 5,
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography sx={{ width: "10rem", textAlign: "left" }}>
                {getLastSunday().getDate()}.{" "}
                {getLastSunday().toLocaleString("pt-br", { month: "short" })}.{" "}
                {getLastSunday().toLocaleString("pt-br", { weekday: "short" })}
              </Typography>
              <Stack>
                <Stack direction="row">
                  <Circle style={{ fill: "#A254DF" }} />
                  <Typography sx={{ ml: 2 }}>
                    10:00 até 11:00 Consulta Neurológica - Paciente Romário
                    souza araújo
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Circle style={{ fill: "#65C94D" }} />
                  <Typography sx={{ ml: 2 }}>
                    10:00 até 11:00 Consulta Neurológica - Paciente Romário
                    souza araújo
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack
              direction="row"
              sx={{
                maxHeight: "5rem",
                width: "100%",
                borderBottom: "1px solid #ccc",
                p: 5,
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography sx={{ width: "10rem", textAlign: "left" }}>
                {getLastSunday().getDate()}.{" "}
                {getLastSunday().toLocaleString("pt-br", { month: "short" })}.{" "}
                {getLastSunday().toLocaleString("pt-br", { weekday: "short" })}
              </Typography>
              <Stack>
                <Stack direction="row">
                  <Circle style={{ fill: "#A254DF" }} />
                  <Typography sx={{ ml: 2 }}>
                    10:00 até 11:00 Consulta Neurológica - Paciente Romário
                    souza araújo
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Circle style={{ fill: "#65C94D" }} />
                  <Typography sx={{ ml: 2 }}>
                    10:00 até 11:00 Consulta Neurológica - Paciente Romário
                    souza araújo
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack
              direction="row"
              sx={{
                maxHeight: "5rem",
                width: "100%",
                borderBottom: "1px solid #ccc",
                p: 5,
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography sx={{ width: "10rem", textAlign: "left" }}>
                {getLastSunday().getDate()}.{" "}
                {getLastSunday().toLocaleString("pt-br", { month: "short" })}.{" "}
                {getLastSunday().toLocaleString("pt-br", { weekday: "short" })}
              </Typography>
              <Stack>
                <Stack direction="row">
                  <Circle style={{ fill: "#A254DF" }} />
                  <Typography sx={{ ml: 2 }}>
                    10:00 até 11:00 Consulta Neurológica - Paciente Romário
                    souza araújo
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Circle style={{ fill: "#65C94D" }} />
                  <Typography sx={{ ml: 2 }}>
                    10:00 até 11:00 Consulta Neurológica - Paciente Romário
                    souza araújo
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack
              direction="row"
              sx={{
                maxHeight: "5rem",
                width: "100%",
                borderBottom: "1px solid #ccc",
                p: 5,
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography sx={{ width: "10rem", textAlign: "left" }}>
                {getLastSunday().getDate()}.{" "}
                {getLastSunday().toLocaleString("pt-br", { month: "short" })}.{" "}
                {getLastSunday().toLocaleString("pt-br", { weekday: "short" })}
              </Typography>
              <Stack>
                <Stack direction="row">
                  <Circle style={{ fill: "#A254DF" }} />
                  <Typography sx={{ ml: 2 }}>
                    10:00 até 11:00 Consulta Neurológica - Paciente Romário
                    souza araújo
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Circle style={{ fill: "#65C94D" }} />
                  <Typography sx={{ ml: 2 }}>
                    10:00 até 11:00 Consulta Neurológica - Paciente Romário
                    souza araújo
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack
              direction="row"
              sx={{
                maxHeight: "5rem",
                width: "100%",
                borderBottom: "1px solid #ccc",
                p: 5,
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography sx={{ width: "10rem", textAlign: "left" }}>
                {getLastSunday().getDate()}.{" "}
                {getLastSunday().toLocaleString("pt-br", { month: "short" })}.{" "}
                {getLastSunday().toLocaleString("pt-br", { weekday: "short" })}
              </Typography>
              <Stack>
                <Stack direction="row">
                  <Circle style={{ fill: "#A254DF" }} />
                  <Typography sx={{ ml: 2 }}>
                    10:00 até 11:00 Consulta Neurológica - Paciente Romário
                    souza araújo
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Circle style={{ fill: "#65C94D" }} />
                  <Typography sx={{ ml: 2 }}>
                    10:00 até 11:00 Consulta Neurológica - Paciente Romário
                    souza araújo
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack
              direction="row"
              sx={{
                maxHeight: "5rem",
                width: "100%",
                borderBottom: "1px solid #ccc",
                p: 5,
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography sx={{ width: "10rem", textAlign: "left" }}>
                {getLastSunday().getDate()}.{" "}
                {getLastSunday().toLocaleString("pt-br", { month: "short" })}.{" "}
                {getLastSunday().toLocaleString("pt-br", { weekday: "short" })}
              </Typography>
              <Stack>
                <Stack direction="row">
                  <Circle style={{ fill: "#A254DF" }} />
                  <Typography sx={{ ml: 2 }}>
                    10:00 até 11:00 Consulta Neurológica - Paciente Romário
                    souza araújo
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Circle style={{ fill: "#65C94D" }} />
                  <Typography sx={{ ml: 2 }}>
                    10:00 até 11:00 Consulta Neurológica - Paciente Romário
                    souza araújo
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack
              direction="row"
              sx={{
                maxHeight: "5rem",
                width: "100%",
                borderBottom: "1px solid #ccc",
                p: 5,
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography sx={{ width: "10rem", textAlign: "left" }}>
                {getLastSunday().getDate()}.{" "}
                {getLastSunday().toLocaleString("pt-br", { month: "short" })}.{" "}
                {getLastSunday().toLocaleString("pt-br", { weekday: "short" })}
              </Typography>
              <Stack>
                <Stack direction="row">
                  <Circle style={{ fill: "#A254DF" }} />
                  <Typography sx={{ ml: 2 }}>
                    10:00 até 11:00 Consulta Neurológica - Paciente Romário
                    souza araújo
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Circle style={{ fill: "#65C94D" }} />
                  <Typography sx={{ ml: 2 }}>
                    10:00 até 11:00 Consulta Neurológica - Paciente Romário
                    souza araújo
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Box>
        </>
      )}

      {format == "Semana" && type == "Calendário" && (
        <div className={styles.week}>
          <div className={styles.day}>
            <div>Domingo</div>
            <div className={styles.dayNumber}>1</div>
          </div>
          <div className={styles.day}>
            <div>Segunda</div>
            <div className={styles.dayNumber}>2</div>
          </div>
          <div className={styles.day}>
            <div>Terça</div>
            <div className={styles.dayNumber} active>
              3
            </div>
          </div>
          <div className={styles.day}>
            <div>Quarta</div>
            <div className={styles.dayNumber}>4</div>
          </div>
          <div className={styles.day}>
            <div>Quinta</div>
            <div className={styles.dayNumber}>5</div>
          </div>
          <div className={styles.day}>
            <div>Sexta</div>
            <div className={styles.dayNumber}>6</div>
          </div>
          <div className={styles.day}>
            <div>Sábado</div>
            <div className={styles.dayNumber}>7</div>
          </div>
          <div className={styles.dayAgenda}>
            <TagAgendamentos start="08:00" end="09:00" type="Nutrição" />
            <TagAgendamentos start="08:00" end="09:00" type="Psicologia" />
            <TagAgendamentos start="08:00" end="09:00" type="Neurologia" />
          </div>
          <div className={styles.dayAgenda}></div>
          <div className={styles.dayAgenda}></div>
          <div className={styles.dayAgenda}></div>
          <div className={styles.dayAgenda}></div>
          <div className={styles.dayAgenda}></div>
          <div className={styles.dayAgenda}></div>
        </div>
      )}

      {format === "Dia" && (
        <>
          <Box>
            {Object.keys(horarios).map((horario, index) => (
              <Stack
                direction="row"
                sx={{
                  minHeight: "5rem",
                  widows: "100%",
                  borderBottom: "1px solid #ccc",
                  p: 1,
                }}
                key={index}
                gap={2}
              >
                <Typography
                  sx={{
                    width: "100px",
                    minWidth: "100px",
                    textAlign: "left",
                    fontWeight: 500,
                    color: "#737373",
                    fontSize: "18px",
                  }}
                >
                  {horarios[horario]}
                </Typography>
                <Stack gap={2} flexDirection={"row"} flexWrap={"wrap"}>
                  {handleAgendamentosPorHorario(horario)}
                </Stack>
              </Stack>
            ))}
          </Box>
        </>
      )}

      <ModalDialogs
        open={openModal}
        onClose={() => handleModalClose()}
        title="Consulta"
        maxWidth="800px"
        {...(AppointmentSelected.status !== 1
          ? {
              secondaryButtonText: "Fechar",
              onActionSecondary: () => handleModalClose(),
            }
          : {
              onActionPrimary: () =>
                editing ? handleSubmit() : setEditing(true),
              primaryButtonText: editing ? "Salvar" : "Editar",
              ...(editing
                ? {
                    secondaryButtonText: "Cancelar",
                    onActionSecondary: () => setEditing(false),
                  }
                : {
                    secondaryButtonText: "Cancelar consulta",
                    onActionSecondary: () => setOpenCancelAppointment(true),
                  }),
            })}
        // onActionPrimary={() => (editing ? handleSubmit() : setEditing(true))}
        // primaryButtonText={editing ? "Salvar" : "Editar"}
        // {...(editing && {
        //   secondaryButtonText: "Cancelar",
        //   onActionSecondary: () => setEditing(false),
        // })}
        body={
          <Stack sx={{ width: { xs: "100%", md: "800px" } }}>
            <Grid
              container
              gap={"24px 16px"}
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                boxSizing: "border-box !important",
                padding: 3,
                textAlign: "left",
              }}
              width="100%"
            >
              <Grid item>
                <Stack spacing={1}>
                  <Typography
                    sx={{
                      fontFamily: "Nunito",
                      fontSize: "16px",
                      fontWeight: 600,
                      lineHeight: "22px",
                      color: "#063f5e",
                    }}
                  >
                    Local de atendimento
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Nunito",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "22px",
                      color: "#737373",
                      textTransform: "capitalize",
                    }}
                  >
                    {AppointmentSelected?.estabelecimento &&
                      AppointmentSelected.estabelecimento.nome}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item>
                <Stack spacing={1}>
                  <Typography
                    sx={{
                      fontFamily: "Nunito",
                      fontSize: "16px",
                      fontWeight: 600,
                      lineHeight: "22px",
                      color: "#063f5e",
                    }}
                  >
                    Profissional responsável
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Nunito",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "22px",
                      color: "#737373",
                      textTransform: "capitalize",
                    }}
                  >
                    {AppointmentSelected?.vinculo &&
                      AppointmentSelected.vinculo.usuario.nome}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item>
                <FieldAutocomplete
                  label="Paciente"
                  isEditField={editing}
                  noOptionsText={"Nenhum resultado encontrado"}
                  getOptionLabel={(option) => {
                    if (option.nome) {
                      return `${option.cpf} - ${option.nome}`;
                    } else {
                      return "Pesquisar paciente";
                    }
                  }}
                  options={patientList}
                  value={patient}
                  disabled
                  setValue={(e, newValue) => setPatient(newValue)}
                  disablePortal={true}
                  required
                />
              </Grid>
              <Grid item>
                <FieldSelect
                  label="Tipo da consulta"
                  value={consultType}
                  setValue={(value) => setConsultType(value)}
                  items={consultTypes}
                  isEditField={editing}
                  required
                />
              </Grid>
              <Grid item>
                <FieldAutocomplete
                  label="Equipe de saúde interna"
                  multiple
                  isEditField={editing}
                  noOptionsText={"Nenhum resultado encontrado"}
                  getOptionLabel={(option) =>
                    `${option.nome} - ${option.perfil} - ${option.conselho} - ${option.numero_conselho}` ||
                    ""
                  }
                  required={perfilAdministrador}
                  freeSolo
                  options={internalHealthTeamList}
                  value={internalHealthTeam}
                  setValue={(e, newValue) =>
                    setInternalHealthTeam(newValue.map((item) => item))
                  }
                  renderTags={() => null}
                />
                <Stack
                  direction="row"
                  flexWrap="wrap"
                  sx={{
                    mt: 1,
                    ...(!editing && {
                      gap: 0,
                      marginTop: "-38px",
                    }),
                  }}
                >
                  {internalHealthTeam.map((v, index) => (
                    <Chip
                      disabled={!editing}
                      sx={{
                        ...(editing
                          ? {
                              background: "#D3E3EB",
                              color: "#1E729F",
                              margin: "4px",
                            }
                          : {
                              background: "#ffff",
                              marginLeft: "-11px",
                              opacity: "1 !important",
                              fontSize: "16px",
                              color: "#9e9e9e",
                              "& .MuiChip-deleteIcon": {
                                color: "transparent",
                              },
                            }),
                      }}
                      key={v.co_id}
                      label={`${v.nome} - ${v.perfil} - ${v.conselho} - ${v.numero_conselho}`}
                      onDelete={(valor) => {
                        setInternalHealthTeam((prevState) =>
                          internalHealthTeam.filter(
                            (data) => data.co_id !== v.co_id
                          )
                        );
                      }}
                    />
                  ))}
                </Stack>
              </Grid>
              <Grid item position={"relative"}>
                <FieldAutocomplete
                  label="Equipe de saúde externa"
                  multiple
                  isEditField={editing}
                  noOptionsText={"Nenhum resultado encontrado"}
                  getOptionLabel={(option) =>
                    `${option.nome} - ${option.perfil} - ${option.conselho} - ${option.numero_conselho}` ||
                    ""
                  }
                  freeSolo
                  options={externalHealthTeamList}
                  value={externalHealthTeam}
                  setValue={(e, newValue) =>
                    setExternalHealthTeam(newValue.map((item) => item))
                  }
                  renderTags={() => null}
                />
                <Stack
                  direction="row"
                  flexWrap="wrap"
                  sx={{
                    mt: 1,
                    ...(!editing && {
                      gap: 0,
                      marginTop: "-38px",
                    }),
                  }}
                >
                  {externalHealthTeam.map((v, index) => (
                    <Chip
                      disabled={!editing}
                      sx={{
                        ...(editing
                          ? {
                              background: "#D3E3EB",
                              color: "#1E729F",
                              margin: "4px",
                            }
                          : {
                              background: "#ffff",
                              margin: "0px",
                              marginLeft: "-11px",
                              opacity: "1 !important",
                              fontSize: "16px",
                              color: "#9e9e9e",
                              "& .MuiChip-deleteIcon": {
                                color: "transparent",
                              },
                            }),
                      }}
                      key={v.co_id}
                      label={`${v.nome} - ${v.perfil} - ${v.conselho} - ${v.numero_conselho}`}
                      onDelete={(valor) => {
                        setExternalHealthTeam((prevState) =>
                          externalHealthTeam.filter(
                            (data) => data.co_id !== v.co_id
                          )
                        );
                      }}
                    />
                  ))}
                </Stack>
              </Grid>

              <Grid item>
                {editing ? (
                  <Stack flexDirection={"row"} gap={2}>
                    <FieldDatePicker
                      label="Data"
                      value={appointmentDate}
                      setValue={(value) =>
                        setAppointmentDate(formatDateISO8601(value))
                      }
                      defaultValue={null}
                      required
                      isEditField={editing}
                    />
                    <FieldTimePicker
                      label="Hora"
                      value={appointmentTime}
                      setValue={(value) => setAppointmentTime(value)}
                      isEditField={editing}
                      required
                    />
                  </Stack>
                ) : (
                  <>
                    <Typography fontWeight={600} mb={1}>
                      Data e horário
                    </Typography>
                    <Typography
                      color={"#737373"}
                      sx={{
                        textTransform: "capitalize",
                      }}
                    >
                      {dayjs(appointmentDate)
                        .locale("pt-br")
                        .format("dddd, D [de] MMMM [de] YYYY")}
                    </Typography>
                    <Typography color={"#737373"}>
                      {dayjs(appointmentDate).locale("pt-br").format("HH[h]mm")}{" "}
                      ás{" "}
                      {dayjs(appointmentDate)
                        .add(30, "minute") // Adiciona 30 minutos
                        .locale("pt-br")
                        .format("HH[h]mm")}{" "}
                    </Typography>
                  </>
                )}
              </Grid>
            </Grid>
            <Divider />
          </Stack>
        }
      />
      <ModalDialogs
        open={openModalSuccess}
        onClose={() => setOpenModalSuccess(false)}
        title="Sucesso"
        modalType="success"
        body={
          <Box sx={{ width: { xs: "100%", sm: "400px" } }}>
            A operação foi concluída com sucesso
          </Box>
        }
      />
      <ModalDialogs
        open={openModalCancelAppointment}
        onClose={() => setOpenCancelAppointment(false)}
        title="Cancelar consulta"
        modalType="error"
        onActionPrimary={() => handleCancelAppointment()}
        onActionSecondary={() => setOpenCancelAppointment(false)}
        secondaryButtonText="Não"
        primaryButtonText="Sim"
        body={
          <>
            <Box sx={{ width: { xs: "100%", sm: "400px" } }}>
              Deseja realmente cancelar a consulta?
            </Box>
          </>
        }
      />
      {openErro && (
        <Snackbar
          open
          onClose={() => setOpenErro(false)}
          autoHideDuration={5000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          message={mensagemErro}
        >
          <Alert severity="error" onClose={() => setOpenErro(false)}>
            {" "}
            {mensagemErro}{" "}
          </Alert>
        </Snackbar>
      )}
      <Modal
        open={isSend}
        onClose={() => {}}
        aria-labelledby="IsLoading"
        aria-describedby="IsLoading"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "9rem",
            p: 4,
            outline: "none",
            background: "transparent !important",
          }}
        >
          <CircularProgress
            size="5rem"
            sx={{
              color: "#ffff",
            }}
          />
        </Box>
      </Modal>
    </Box>
  );
}
